<template>
  <div class="card listing-card">
    <form @submit.prevent class="needs-validation" novalidate>
      <div v-if="serverError" class="alert alert-danger" role="alert">
        {{serverError}}
      </div>
      <div class="card-body">
        <div class="label-text">
          <span v-if="isAdd">Add Contact</span>
          <span v-if="!isAdd">Edit Contact</span>
        </div>
        <hr>
        <div class="row mb-2">
          <div class="col-lg-9">
            <div class="form-group row">
              <label class="col-lg-4 label-text">
                <span v-if="isAdd" class="text-danger">*</span>Name
              </label>
              <div class="col-lg-8">
                {{ contact.crmContact | contactName }}
              </div>
            </div>
            <div class="form-group row">
              <label class="col-lg-4 label-text">
                <span v-if="isAdd" class="text-danger">*</span>Address
              </label>
              <div class="col-lg-8"
                v-html="$options.filters.contactAddress(contact.crmContact)">
              </div>
            </div>
          </div>
          <div v-if="isAdd" class="col-lg-3">
            <SearchContactsModal
              :modalId="'contactSearch-' + contact.id"
              @set-contact="updateContact"
              :parentType="parentType"
              :parentId="parentId"
            />
          </div>
        </div>
        <div v-if="contactError" class="invalid-feedback d-block mb-2">
          Contact is required. Please use Search Contacts to select a contact.
        </div>
        <div class="form-group row">
          <label for="roles" class="col-lg-3 label-text">
            <span class="text-danger">*</span>Role(s)
          </label>
          <div class="loading col-lg-5" v-if="rolesLoading">
            Loading...
          </div>
          <div class="col-lg-9">
            <b-form-checkbox-group
              v-if="!rolesLoading"
              v-model="contact.roleIds"
              v-validate="'multi_required'"
              data-vv-as="role"
              name="roles"
            >
              <b-form-checkbox
                v-for="role in roles"
                :key="role.id"
                :value="role.id"
                class="col-md-5 noselect">
                {{ role.name }}
              </b-form-checkbox>
            </b-form-checkbox-group>
            <div v-if="errors.first('roles')" class="invalid-feedback d-block mb-2">
              {{ errors.first('roles') }}
            </div>
            <div v-if="requestorRoleError" class="invalid-feedback d-block mb-2">
              Requestor role is required.
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="contactNotes" class="col-lg-3 label-text">
            Role Details
          </label>
          <div class="col-lg-9">
            <textarea data-vv-as="Notes"
                  type="textarea"
                  class="form-control"
                  name="notes"
                  v-model="contact.notes"
                  placeholder="Enter Role Details"
                  rows="2"
                  maxlength="100" />
            <small v-if="!errors.first('notes')" class="form-text text-muted">
              Max 100 characters
            </small>
            <div class="invalid-feedback">{{ errors.first('notes') }}</div>
          </div>
        </div>
      </div>
      <div class='card-footer right-align-content'>
        <b-button
          :disabled="submitting"
          variant="danger" class="button-row-spacing"
          v-b-modal="'cancelContactConfirmation-' + contact.id">
          Cancel
        </b-button>
        <b-button
          :disabled="submitting"
          @click="submitWrapper(contact)">
          Save
        </b-button>
      </div>
    </form>
    <CancelModal
      :modalId="'cancelContactConfirmation-' + contact.id"
      @cancelled="cancelEdit">
    </CancelModal>
  </div>
</template>
<script>
import CancelModal from '../CancelModal.vue';
import FormSubmit from '../../mixins/FormSubmit';
import SearchContactsModal from './SearchContactsModal.vue';

export default {
  name: 'ContactForm',
  components: {
    CancelModal,
    SearchContactsModal,
  },
  mixins: [FormSubmit],
  props: [
    'initialContact',
    'roles',
    'rolesLoading',
    'storeNamespace',
    'parentType',
    'parentId',
  ],
  computed: {
    submitting() {
      return this.$store.state[this.storeNamespace].submitting;
    },
    isAdd() {
      return !this.initialContact.id;
    },
    isRequestorRoleRequired() {
      return this.initialContact.roleIds.includes(39) && this.parentType === 'service' && !this.isUserAdmin();
    },
  },
  data() {
    return {
      serverError: null,
      contactError: false,
      requestorRoleError: false,
      contact: {
        id: this.initialContact.id,
        instrumentId: this.initialContact.instrumentId,
        propertyId: this.initialContact.propertyId,
        serviceId: this.initialContact.serviceId,
        crmContact: this.initialContact.crmContact,
        roleIds: this.initialContact.roleIds,
        crmId: this.initialContact.crmId,
        notes: this.initialContact.notes,
      },
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'contact.roleIds': function () {
      this.checkRequestorRoleError();
    }, 
  },
  methods: {
    cancelEdit() {
      this.$emit('closeForm', this.contact.id);
    },
    updateContact(contactResult) {
      this.contact.crmContact = contactResult;
      this.contact.crmId = contactResult.crmId;
      this.checkContactError();
    },
    submitWrapper(entity) {
      this.checkContactError();
      this.checkRequestorRoleError();
      this.onSubmitToStore(
        entity,
        this.storeNamespace,
        'contact',
        [this.contactError, this.requestorRoleError],
        this.addContactCallback,
      );
    },
    addContactCallback() {
      this.$store.dispatch(`${this.storeNamespace}/fetchEntities`, {
        parentType: this.parentType,
        parentId: this.parentId,
        entityType: 'Contacts',
      });
    },
    checkContactError() {
      this.contactError = !this.contact.crmId;
    },
    checkRequestorRoleError() {
      this.requestorRoleError = this.isRequestorRoleRequired && !this.contact.roleIds.includes(39);
    },
    isUserAdmin() {
      const roles = this.$store.getters['User/getCurrentUser'].idToken ? this.$store.getters['User/getCurrentUser'].idToken.roles.join(', ') : '';
      return roles.includes('Admin');
    },
  },
};
</script>
